import { fetchUser } from '../api';
const getUser = async () => {
    try {
        const user = await fetchUser();
        return user;
    }
    catch (error) {
        throw new Error('Failed to fetch user: ' + error.message);
    }
};
export default getUser;
